export default __webpack_public_path__ + "static/media/Samra_Mazhar.d75415bb.png";